import { breakpoint } from '@pocketlaw/tetris/deprecated';
import styled from 'styled-components';
export const MediaQuery = styled.div `
  display: none;

  @media ${(props) => breakpoint[props.breakpoint]} {
    display: block;
  }
`;
